import { render, staticRenderFns } from "./HerhaalFacturen.vue?vue&type=template&id=4440a8e2"
import script from "./HerhaalFacturen.vue?vue&type=script&lang=js"
export * from "./HerhaalFacturen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports